/**
 * 監査ログ（顧客向け）。画面そのものは 2 アプリで共有している
 * （設計の「同じ 1 本のデータを絞って見せる」をそのまま形にしたもの）。
 *
 * ヘルプはこの面だけに渡す。オペレーター向けの面に、顧客向けの読み方を
 * そのまま置かない。
 */

import { AuditLogScreen } from "visumo-data-agent-web-shared";

import { HelpIcon } from "../help/HelpIcon";

export function AuditPage() {
  return (
    <AuditLogScreen
      description="この会社で行われた操作の記録です。新しい順に並びます。"
      help={<HelpIcon slug="audit/log" />}
    />
  );
}
